import { Injectable, OnDestroy } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { AppInsightsServiceDirective } from '@app/shared/services/app-insights.service';
import { AuthService } from '@app/shared/services/auth.service';
import { ApplicationInsightEvent } from '@app/shared/enums';

@Injectable({
  providedIn: 'root',
})
export class FeatureDurationLoggerService implements OnDestroy {
  appinsightActivityId: string;
  subfeature: string = '';
  clickEventSubscription: Subscription = new Subscription();

  constructor(
    private authService: AuthService,
    private appInsightsServiceDirective: AppInsightsServiceDirective,
  ) {
    this.appinsightActivityId = `${this.authService.sessionId}-${new Date().getTime()}`;
  }

  public ngOnDestroy() {
    this.clickEventSubscription.unsubscribe();
  }

  public initializeApplicationInsights(subfeature: string) {
    this.subfeature = subfeature;

    this.logActivityToApplicationInsights();
    const clickEvent = fromEvent(document, 'click', { passive: true });
    this.clickEventSubscription = clickEvent.subscribe((e) => this.logActivityToApplicationInsights());
  }

  logActivityToApplicationInsights() {
    this.appInsightsServiceDirective.logEvent(ApplicationInsightEvent.featureActivity, {
      ActivityId: this.appinsightActivityId,
      Feature: this.subfeature,
      UserType: this.authService.currentUser.roleName,
    });
  }

  unsubscribbe() {
    this.clickEventSubscription.unsubscribe();
  }
}
